<template>
  <div class="warning-message">
    <img src="../../assets/waving_hand.svg" aria-hidden />
    <slot />
  </div>
</template>

<style lang="postcss">
.warning-message {
  background-color: #f7f6f3;
  padding: 8px;
  border-radius: 22px;
  width: fit-content;
  display: flex;
  gap: var(--attest-spacing-2);
  align-items: center;
  justify-content: space-around;
}
</style>
